import { useNavigate } from 'react-router-dom'
import PageHeader from '../components/PageHeader.jsx'
import PartForm from '../components/PartForm.jsx'
import { useInventory } from '../components/InventoryProvider.jsx'
import { useToast } from '../components/ToastProvider.jsx'

export default function PartNewPage() {
  const navigate = useNavigate()
  const { createPart } = useInventory()
  const { show } = useToast()

  async function handleSubmit(form) {
    const part = await createPart(form)
    show('신규 부품을 등록했습니다.')
    navigate(`/inventory/${part.id}`)
  }

  return (
    <div className="page">
      <PageHeader title="신규부품 등록" description="확인된 사양만 입력하고, 불확실한 항목은 비워 두세요." />
      <PartForm
        isNew
        submitLabel="등록"
        onSubmit={handleSubmit}
        onCancel={() => navigate('/inventory')}
      />
    </div>
  )
}
